
/**
 * Handle script for FAQ sections primarily on category and product pages.
 */
export class FAQSection {

    constructor() {
        if (document.getElementById('faq-section')) {
            this.handle_faq_accordion();
        }

        if (document.getElementById('tv-faq-section')) {
            this.bind();
        }
    }

    /**
     * Attach events and map references to the DOM.
     *
     * @returns {void}
     */
    bind() : void {
        const faq_questions = document.getElementsByClassName('tv-faq-question');
        for (const faq_question of faq_questions) {
            faq_question.addEventListener('click', this.toggle_faq.bind(this, faq_question));
        }
        
    }

     /**
     * Handle the legacy FAQ section's accordion functionality.
     *
     * @returns {void}
     */
    handle_faq_accordion() : void {
        const faq_section = document.getElementById('faq-section');

        if (faq_section && window.innerWidth) {
            const faq_headers = faq_section.querySelectorAll('p.tv-font-style__bold');
            for (const faq_header of faq_headers) {
                const faq_content = faq_header.nextElementSibling;

                // Hide sections by default.
                if (faq_content) {
                    faq_content.classList.add('tv-display__none');
                }
                faq_header.addEventListener('click', () => {
                    if (faq_content.classList.contains('tv-display__none')) {
                        faq_content.classList.remove('tv-display__none');
                    } else {
                        faq_content.classList.add('tv-display__none');
                    }
                });
            }
        }
    }

    /**
     * Handle the FAQ section's accordion functionality.
     *
     * @returns {void}
     */
    toggle_faq(faq_element : HTMLElement) : void {
        const faq_answer = faq_element.parentElement.querySelector('.tv-faq-answer') as HTMLElement;
        if (faq_element.classList.contains('tv-faq-active')) {
            faq_element.classList.remove('tv-faq-active');
            faq_answer.classList.add('tv-display__none');
        } else {
            faq_element.classList.add('tv-faq-active');
            faq_answer.classList.remove('tv-display__none');
        }
    }

}

export function init_faq_section() : void {
    // Run if we detect the FAQ section.
    if (document.getElementById('tv-faq-section') || document.getElementById('faq-section')) {
        (() => new FAQSection())();
    }
}
